/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CheckIcon from "vux/src/components/check-icon/index.vue";
import Sticky from "vux/src/components/sticky/index.vue";
import UserLogo from '@/components/UserLogo';
import Popup from '@/pages/mine/popup';
export default {
  name: 'ScrollerItem',
  components: {
    CheckIcon: CheckIcon,
    UserLogo: UserLogo,
    Popup: Popup
  },
  props: {
    imgUrl: String,
    statecolor: [String, Object],
    name: String,
    value: {
      type: [String, Number],
      default: ''
    },
    showflag: Boolean,
    logflag: {
      type: Boolean,
      default: false
    },
    product_category_name: String,
    product_code: String,
    service_category: String,
    fk_t_production_category_id: [String, Number]
  },
  data: function data() {
    return {
      isCheck: false
    };
  },
  computed: {
    // 是否是两行列表
    size: function size() {
      return this.$parent.$parent.size;
    },
    // 是否显示图片
    showImage: function showImage() {
      return this.$parent.$parent.showImage;
    },
    // 图片是否为圆形
    circleImage: function circleImage() {
      return this.$parent.$parent.circleImage;
    },
    // 是否开启多选
    check: function check() {
      return this.$parent.$parent.check;
    },
    miniStyle: function miniStyle() {
      var miniStyle = {};

      if (this.size === 'middle') {
        miniStyle.height = '6.8rem';
        miniStyle.padding = '.8rem 1rem';
        miniStyle.imgHeightWidth = '3.2rem';
      }

      if (this.size === 'mini') {
        miniStyle.height = '4.8rem';
        miniStyle.padding = '.8rem 1rem';
        miniStyle.imgHeightWidth = '3.2rem'; // miniStyle.contentMarginTop = '.24rem'
      } else if (this.size === 'normal') {
        miniStyle.height = '7.2rem';
        miniStyle.padding = '1.2rem 1rem';
        miniStyle.imgHeightWidth = '4.8rem';
        miniStyle.contentMarginTop = '.36rem';
      } else if (this.size === 'large') {
        miniStyle.height = '8.72rem';
        miniStyle.padding = '1.2rem 1rem';
        miniStyle.imgHeightWidth = '6.2rem';
        miniStyle.contentMarginTop = '.36rem';
      }

      if (this.circleImage) {
        miniStyle.imgBorderRadius = '50%';
      } else {
        miniStyle.imgBorderRadius = '.24rem';
      }

      return miniStyle;
    },
    // 选中列表
    checkList: {
      get: function get() {
        return this.$parent.$parent.checkList;
      },
      set: function set(newVal) {
        this.$parent.$parent.checkList = newVal;
      }
    },
    // 选中列表
    checkListMsg: {
      get: function get() {
        return this.$parent.$parent.checkListMsg;
      },
      set: function set(newVal) {
        this.$parent.$parent.checkListMsg = newVal;
      }
    }
  },
  watch: {
    // 将选中状态同步至checkList
    isCheck: function isCheck(val) {
      var _this = this;

      var index = this.checkList.indexOf(this.value);

      if (val) {
        if (index === -1) {
          this.checkList.push(this.value);
        }

        if (this.checkListMsg.every(function (item) {
          return item.value !== _this.value;
        })) {
          this.checkListMsg.push({
            value: this.value,
            imgUrl: this.imgUrl,
            name: this.name,
            product_category_name: this.product_category_name,
            product_code: this.product_code,
            service_category: this.service_category,
            fk_t_production_category_id: this.fk_t_production_category_id
          });
        }
      } else {
        if (index !== -1) {
          this.checkList.splice(index, 1);
        }

        this.checkListMsg.forEach(function (item, index) {
          if (item.value === _this.value) _this.checkListMsg.splice(index, 1);
        });
      }
    },
    checkListMsg: {
      handler: function handler(val) {
        var _this2 = this;

        if (val.some(function (item) {
          return item.value === _this2.value;
        })) {
          this.isCheck = true;
        } else {
          this.isCheck = false;
        }
      },
      immediate: true // if (val.indexOf(this.value) !== -1) {
      //   this.isCheck = true
      // } else {
      //   this.isCheck = false
      // }

    }
  },
  created: function created() {},
  methods: {
    getItem: function getItem() {
      if (this.check) return;
      var obj = {
        product_category_name: this.product_category_name,
        product_code: this.product_code,
        service_category: this.service_category,
        fk_t_production_category_id: this.fk_t_production_category_id,
        product_name: this.name,
        id: this.fk_t_production_category_id
      };
      this.$parent.$parent.$emit('on-check-ok', obj);
      this.$parent.$parent.$emit('getList', obj);
    }
  }
};